import { render, staticRenderFns } from "./GameTabTemplate.vue?vue&type=template&id=315d2f52&scoped=true&"
import script from "./GameTabTemplate.vue?vue&type=script&lang=js&"
export * from "./GameTabTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GameTabTemplate.vue?vue&type=style&index=0&id=315d2f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d2f52",
  null
  
)

export default component.exports